const Texts = {
  "en": {

    "btn_start": "Contact Us",

    "company": {
      "name": "BITSIMPLY AUSTRALIA",
      "link": "BitSimply.com.au",
    },

    // headline section 
    "banner": {
      "uid": "Home",
      "title": "I need to ... Crypto, Defi, NFT and DAO?",
      "subtitle":
        // "We specialise in assisting individuals, SME, family offices and SMSF with information, training and technical support to buy and hold cryptocurrency assets from start to finish.",
        "We help early stage startups, companies, individuals who want to invest or launch products and services in Crypto, Defi, NFT and DAOs.  Our expertise covers product design, tokenomics, technical architecture and implementation, security, tax, liability, legal and regulatory considerations by region.  Whether you are an early stage startup, an established business or an investment firm, we are here to help.",
    },

    // Services section 
    "services": {
      "uid": "Services",
      "title": "How We help?",

      "subtitle":
        "We privide on consultation, training and technology advice on Crypto, Defi, NFTs and DAOs. ",

      "disclaimer":
        "Note: Our services are educational and technical and not financial.  Consult finance and tax professionals for personalised finance and tax related services.",

      "types": {
        "Web3": {
          "title": "Defi / Web3 / Blockchain",
          "subtitle": "We advise defi and blockchain projects on challenges such as choosing a tech stack and blockchains. We also provide general education and background on the space.",
          "icon": "uil uil-bill",
        },
        "NFTs": {
          "title": "NFTs",
          "subtitle": "We help review your NFT launch strategy, tokenomics and product design.  We also help connect our clients with a network of companies and service providers where needed. ",
          "icon": "uil uil-bill",
        },
        "DAOs": {
          "title": "DAOs",
          "subtitle": "DAO structures are an emerging mode of community collaboration and communication.  We help assess DAO structures, tokenomics (if any) and governance structure.",
          "icon": "uil uil-bill",
        },
        "intro": {
          "title": "How Crypto, NFTs and DAOs Works?",
          "subtitle": "We provide general education on what crypto, nfts and DAOs are, how they work, their history, current state of the industry and emerging trends.",
          "icon": "uil uil-bitcoin-circle",
        },
        "buying": {
          "title": "How to Buy & Store?",
          "subtitle": "We explain the ways one can obtain Bitcoin, crypto, nfts and participate in DAOs.  How you should hold and safeguard your crypto assets from theft and loss (e.g., estate planning).",
          "icon": "uil uil-gold",
        },
        "holding": {
          "title": "Crypto / Web3 in your Business?",
          "subtitle": "We consult on ways you can include Crypto as part of your business including how to accept cryptocurrency as payment, payroll or hold as coprorate treasury.",
          "icon": "uil uil-transaction",
        },
        "tax": {
          "title": "Taxation and Law",
          "subtitle": "We provide general education on taxation, legal and geopolitical implications when offering products and services in this space.  See tax and finance professionals for individual advice.",
          "icon": "uil uil-bill",
        },
        "training": {
          "title": "Training",
          "subtitle": "We provide training using our sandboxed software and hardware so you and your team are confident with handling crypto currencies before going live.  We can also provide personalised training programs for individuals and organisations.",
          "icon": "uil uil-invoice",
        },
        "tech": {
          "title": "Tech Support",
          "subtitle": "We provide technical and related educational support including setting up software, hardware and training on their use.  We also help review smart contracts and even develop custom software if required.",
          "icon": "uil uil-incoming-call",
        },
      },
    },


    // who we help
    "whowehelp": {
      "uid": "Clients",
      "title": "People we help",
      "subtitle": "We specialise in early stage startups, SME and investors.",
      "types": {
        "private": {
          "title": "Startups",
          "subtitle": "Early stage startups who needs advise and support for launching and / or grow their products and services.",
          "icon": "uil uil-incoming-call",
        },
        "sme": {
          "title": "SME",
          "subtitle": "Companies interested in adding Crypto, NFT and DAO related products and services.",
          "icon": "uil uil-incoming-call",
        },
        "smsf": {
          "title": "Investors / SMSF / Family Offices",
          "subtitle": "Self managed super funds, family offices who are interested in this space and require technical support.",
          "icon": "uil uil-incoming-call",
        },

      }
    },


    "howitworks": {
      "uid": "Process",
      "title": "How do we work?",
      "subtitle": "First an introduction to discuss how we work, your needs and what we can offer.  We prepare a quote for the services needed and proceed as agreed.  See the steps for more details.",
      "details": [
        {
          "title": "Step 1: Introduction",
          "text": "A Q&A to discuss needs.  We capture the requirements and provide a quote for whats needed."
        },
        {
          "title": "Step 2: Consultation",
          "text": "We prepare and provide detailed consultation, training and / or support based on client needs.",
        },
        {
          "title": "Step 3: Technical Report & Instructions",
          "text": "If applicable, we parepare a document that includes instructions and technical processes needed e.g., setting up cryptocurrency wallets and how to secure them.  Recommendations on technical decisions such as type of account setup (e.g., multisig vs single, hot vs cold wallets) and the hardware and software requirements with instructions."
        },
        {
          "title": "Step 4: Technical Walkthrough / Support",
          "text": "If applicable, we walk through instructions provided, provide training and support on the processes documented."
        }
      ]
    },

    "pricing": {
      "uid": "Pricing",
      "title": "Pricing Guide",
      "subtitle": "Below are standard pricing packages.  Pay in Bitcoin or Ethereum are encouraged and entitled to a 10% discount.  Note: this is a guide and final prices may vary depending on client needs such as additional consultation times and support.  All prices are inc GST. ",
      "packages": [
        {
          "title": "Consultation",
          "price": "990",
          "items": [
            "Consultation (up to 2 hours).",
            "Training / Tech Support (1x1 hour or 2x30 mins).",
          ]
        },
        {
          "title": "Consult & Instruct",
          "price": "3300",
          "items": [
            "Consultation (up to 4 hours).",
            "Training (2x2 hour or 1x4 hour)",
            "Tech Support (4x30 mins).",
            "Instruction Manual."
          ]
        },
        {
          "title": "Custom",
          "price": "Custom",
          "items": [
            "Based on client needs.",
          ]
        }
      ]
    },

    "about": {
      "uid": "About",
      "title": "About Us",
      "subtitle": "",
      "highlights": [
        {
          "img": "images/cryptoconsult/ceo.jpg",
          "heading": "Our Mission",
          "text": "The cryptocurrency industry is young and evolving rapidly.  It is full of jargons, buzz words designed to confuse, impress and / or mislead people. BitSimply exists to help clients quickly get up to speed, stay informed and become confident operators of cryptocurrencies.  We seek to empower our clients with knowledge, confidence and the tools for managing this asset class.",
          "footer": "Dr Lie M. Tang",
          "footer2": "CEO, BitSimply",
        },
        {
          "img": "images/cryptoconsult/compas.jpg",
          "heading": "Our Philosophy",
          "text": "We see our primary role is one of education and empowerment and to provide technical support when needed.",
          "footer": null,
          "footer2": null,
        },
        {
          "img": "images/cryptoconsult/whyus2.jpg",
          "heading": "Why Us?",
          "text": "We are tech industry experts and long term investors in this market.  We have built knowledge, processes and tools which allows us to leverage these to help our clients succeed. ",
          "footer": null,
          "footer2": null,
        },
      ]
    },


    "contact": {
      "uid": "Contact",
      "title": "Contact Us",
      "subtitle": "Contact us to begin the consultation process.",
      "ways": {
        "schedule": {
          "title": "Schedule a Call",
          "icon": "uil uil-calendar-alt",
          "ref": "https://calendly.com/liebitsimply/intro",
          "label": "Calendly",
          "type": "calendly"
        },
        "email": {
          "title": "Email",
          "icon": "uil uil-envelope",
          "ref": "mailto:info@bitsimply.com.au",
          "label": "info@bitsimply.com.au",
          "type": "email"
        },
        // "phone": {
        //   "title": "Phone",
        //   "icon": "uil uil-incoming-call",
        //   "ref": "tel:+61434323002",
        //   "label": "+61 434 323 002",
        //   "type": "phone"
        // },
        "whatsapp": {
          "title": "WhatsApp",
          "icon": "uil uil-whatsapp",
          "ref": "https://wa.me/61434323002?text=Hi",
          "label": "BitSimply",
          "type": "whatsapp"
        },
        "wechat": {
          "title": "WeChat",
          "icon": "uil uil-comments",
          "ref": " weixin://dl/chat/bitsimply",
          "label": "ID: bitsimply",
          "type": "wechat"
        },
        "telegram": {
          "title": "Telegram",
          "icon": "uil uil-telegram",
          "ref": "tg://msg?text=hi&to=Bitsimply",
          "label": "@Bitsimply",
          "type": "telegram"
        }
      }
    },

    "footer": {
      "uid": "Footer",
      "subtitle": "",
      "newsletter": {
        "title": "Newsletter",
        "subtitle": "Sign up for a monthly latest in bitcoin and the crypto currency market.",
        "input_header": "Write your email ",
        "placeholder": "Your email: "
      },
      "disclaimer": "BITSIMPLY AUSTRALIA offers education and consulting on the cryptocurrency industry in general and IT support in buying, storing and using crypto currencies.  BITSIMPLY AUSTRALIA does not offer financial or taxation advice or service.  Clients are advised to consult finance and tax professionals for investment, finance and tax related services."
    }
  },
  // later can add other languages

}

export default Texts
